import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const ClassSelect = ({ value, onChange, classes, width = 200, ...rest }) => {
    if (!classes) {
        return null;
    }

    const handleKeyDown = (e) => {
        if(e.code !== 'Tab'){
            e.preventDefault();
        }
        if ((e.code === 'Backspace' || e.code === 'Delete') && value !== undefined) {
            onChange(undefined);
        }
    };

    return (
        <Select
            {...rest}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            style={{ width: width }}
            placeholder="Select class"
            aria-label="class filter"
            allowClear={true}
        >
            {classes.map((item) => (
                <Option key={item.classId} value={item.classId}>
                    {item.className}
                </Option>
            ))}
        </Select>
    );
};

export default ClassSelect;